<template>
    <section id="builderWrapper" class="flexContainer fd-c as-s ai-s ac-s">
        <Spinner v-if="loader"></Spinner>
        <header v-if="$route.name === 'Plano' && hasLoadData" class="rel">
            <HeaderPlano v-if="hasLoadData && !isNewPlano"></HeaderPlano>
            <HeaderPlanoMassMarket v-if="hasLoadData && isNewPlano"></HeaderPlanoMassMarket>
            <MenuMainPlano v-if="getShowRestore === false && !isNewPlano"></MenuMainPlano>
        </header>
        <div class="rel content-builder-main">
            <div v-if="hasLoadData" style="height: 100%">
                <div v-if="!isNewPlano" style="height: 100%">
                    <PlanoEditor v-show="isPlano"></PlanoEditor>
                    <GroupEditor v-if="isModuleEditor"></GroupEditor>
                </div>
                <div v-else style="height: 100%">
                    <PlanoEditorMassMarket v-show="isPlano"></PlanoEditorMassMarket>
                    <ModuleEditor v-if="isModuleEditor"></ModuleEditor>
                    <ShelfEditor v-else-if="isShelfEditor"></ShelfEditor>
                </div>
            </div>
            <transition-group name="fade">
                <MenuShades :key="'menuShades'" v-if="canDisplayMenuShades" class="abs sidebar"></MenuShades>
                <ScratchPad :key="'menuScratch'" v-if="canDisplayMenuScratch" class="abs sidebar"></ScratchPad>
                <Favorite :key="'menuScratch'" v-if="canDisplayMenuFavorite" class="abs sidebar"></Favorite>
                <MenuMain :key="'menuLibrary'" v-if="canDisplayMenuLibrary" class="abs sidebar"></MenuMain>
                <Sidebar :key="'comments'" v-if="canDisplayComments"><Comments></Comments></Sidebar>
                <Sidebar :key="'exports'" v-if="canDisplayExports"><Exports></Exports></Sidebar>
                <TicketStrip :key="'ticketstrip'" v-if="canDisplayMenuTicketStrip" class="abs sidebarLeft"></TicketStrip>
            </transition-group>
        </div>
        <ModalFavorite v-if="showModalFavorite === true && getShowRestore === false"></ModalFavorite>
    </section>
</template>
<script>
import Globals from "./../globals";
import { carcassmodel } from "@/store/planonext/carcassmodel";
import HeaderPlano from "./menu/HeaderPlano.vue";
import MenuMainPlano from "./menu/MenuMainPlano.vue";
import MenuMainPlanoMassMarket from "./menu/MenuMainPlanoMassMarket.vue";
import HeaderPlanoMassMarket from "./menu/HeaderPlanoMassMarket.vue";
import PlanoEditor from "./PlanoEditor.vue";
import PlanoEditorMassMarket from "./PlanoEditorMassMarket.vue";
import GroupEditor from "./GroupEditor.vue";
import ModuleEditor from "./ModuleEditor.vue";
import ShelfEditor from "./ShelfEditor.vue";
import MenuShades from "./menu/MenuShades.vue";
import TicketStrip from "./menu/TicketStrip.vue";
import ScratchPad from "./menu/ScratchPad.vue";
import Favorite from "./menu/Favorite.vue";
import ModalFavorite from "./menu/ModalFavorite.vue";
import MenuMain from "./menu/Menu.vue";
import Sidebar from "./menu/Sidebar";
import Comments from "./menu/Comments.vue";
import Exports from "./menu/Exports.vue";
import { stateMixin } from "./mixins/state";
import Spinner from "../common/Spinner";
import { mapGetters, mapActions } from "vuex";
import cacheService from "@/services/cache";

export default {
    mixins: [stateMixin],
    components: {
        Spinner,
        HeaderPlano,
        MenuMain,
        MenuMainPlano,
        MenuMainPlanoMassMarket,
        PlanoEditor,
        GroupEditor,
        ModuleEditor,
        ShelfEditor,
        MenuShades,
        Sidebar,
        ScratchPad,
        Favorite,
        ModalFavorite,
        Comments,
        TicketStrip,
        Exports,
        PlanoEditorMassMarket,
        HeaderPlanoMassMarket
    },
    data() {
        return {
            hasLoadData: false,
            loader: true,
            showRestore: false,
            systemType: null
        };
    },
    computed: {
        isPlano() {
            return this.activeView === "plano";
        },
        isModuleEditor() {
            return this.activeView === "module";
        },
        isShelfEditor() {
            return this.activeView === "shelf";
        },
        isCaddyEditor() {
            return this.activeView === "caddy";
        },

        // A better name
        activeView() {
            return this.getMode;
        },
        ...mapGetters({
            getRestorePlano: "plano/data/getRestorePlano",
            getShowRestore: "plano/data/getShowRestore"
        })
    },
    created() {
        this.getMeubleAction({ id: this.$route.params.id })
            .then(res => {
                this.systemType = this.getPlanoDetails.template.systemType.id;
                this.hasLoadData = true;
                this.loader = false;
                return res;
            })
            .catch(res => {
                console.error(res);
                return res;
            });
        this.showRestore = cacheService.get("showRestore");
    },
    beforeDestroy() {
        this.hasLoadData = false;
        this.cleanMeuble();
        this.setMode("plano");
        this.closeAllMenus();
    },
    methods: {
        ...mapActions("plano/status", {
            closeAllMenus: "closeAllMenus"
        }),

        isNotSafari() {
            return Globals.getNavigator() !== Globals.NAVIGATOR_SAFARI;
        }
    }
};
</script>
<style lang="scss">
.content-builder-main {
    height: 100%;
    background-color: #f4f4f4;
}

.visibility {
    visibility: hidden;
}

#builderWrapper {
    overflow: hidden;
    flex: 1 100%;
}

.sidebar {
    width: 25%;
    right: 0;
    z-index: 20;
    border-left: 2px solid #aaa;
}
</style>



// WEBPACK FOOTER //
// Plano.vue?c11e49ca